<template>
  <v-dialog scrollable max-width="1200px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <v-btn color="info" small v-on="on" @click="cargar">Distribuciones</v-btn>
    </template>

    <v-card>
      <v-card-title>Distribuciones</v-card-title>

      <v-card-text>
        <v-data-table :headers="headers" :items="liquidaciones">
          <template v-slot:[`item.action`]="props">
            <v-row>
              <v-col>
                <Confirmar
                  v-if="$store.getters.user.roles.includes('RELIQUIDARHEREDEROS')"
                  boton="REL. HER."
                  small
                  titulo="Reliquidar herederos"
                  @si="reliquidarHerederos(props.item.id)"
                />
              </v-col>
              <v-col>
                <Confirmar
                  v-if="$store.getters.user.roles.includes('RELIQUIDARORDENPAGO')"
                  boton="REL. OP."
                  small
                  titulo="Reliquidar orden de pago"
                  @si="reliquidarOrdenPago(props.item.id)"
                />                
              </v-col>           
              <v-col>
                <LiquidacionResumen
                  :liquidacionId="props.item.id"
                  :descripcion="props.item.generacion.descripcion"
                />
              </v-col>
              <v-col>
                <OrdenesPagos
                  :liquidacionId="props.item.id"
                  :beneficiarioId="null"
                />
              </v-col>
            </v-row>
          </template>
        </v-data-table>
        <v-divider></v-divider>
        <span class="red--text" v-if="errorMessage">{{ errorMessage }}</span>
      </v-card-text>
      <v-card-actions>
        <v-btn color="info" @click="volver">Volver</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import LiquidacionResumen from "./LiquidacionResumen.vue";
import OrdenesPagos from "./OrdenesPagos.vue";
import Confirmar from "@/components/Confirmar.vue";

export default {
  props: ["personaId"],
  data() {
    return {
      showDialog: false,
      liquidaciones: [],
      errorMessage: '',
      headers: [
        { text: "Liq.Id", value: "id" },
        { text: "Descripcion", value: "generacion.descripcion" },
        { text: "Titular", value: "autor.nombreCompleto" },
        { text: "", value: "action" },
      ],
    };
  },
  methods: {
    cargar() {
      axios
        .get("/persona/" + this.personaId + "/getLiquidacion")
        .then((res) => {
          console.log(res.data)
          this.liquidaciones = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    volver() {
      this.showDialog = false;
    },
    reliquidarHerederos(liquidacionId) {
      
      this.errorMessage = '';
      axios
        .patch(
          "/liquidacion/reliquidarHerederos?liquidacionId=" +liquidacionId
        )
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = err.response.data;
        });
    },
    reliquidarOrdenPago(liquidacionId) {
      
      axios
        .patch(
          "/liquidacion/reliquidarOrdenesPagos?liquidacionId=" +liquidacionId
        )
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = err.response.data;
        });
    },
  },
  components: {
    LiquidacionResumen,
    OrdenesPagos,
    Confirmar,
  },
};
</script>